<div class="login-root" (mousemove)="onMouseMove($event)">

  <!-- 3D canvas -->
  <div #canvasWrapper class="canvas-wrap"></div>

  <!-- Vignette -->
  <div class="vignette"></div>

  <!-- Header -->
  <header class="login-header">
    <div class="brand-mark">
      <div class="brand-icon">N</div>
      <span class="brand-label">NGX FINANCIAL</span>
    </div>
    <span class="platform-label">PLATAFORMA v{{ appVersion }}</span>
  </header>

  <!-- Login card -->
  <main class="login-main" *ngIf="phase === 'form' || phase === 'entering'">
    <div class="float-wrap">
      <div class="login-card" #cardEl>

        <!-- Registering Face ID overlay (após login, durante o registro biométrico) -->
        <ng-container *ngIf="registeringFaceId">
          <div class="card-eyebrow">CONFIGURANDO BIOMETRIA</div>
          <h1 class="card-title">Ativando Face ID...</h1>
          <p class="mfa-hint">Autorize quando o dispositivo solicitar.</p>
          <mat-spinner diameter="40" style="margin: 24px auto;"></mat-spinner>
        </ng-container>

        <!-- Credentials step -->
        <ng-container *ngIf="!mfaPending && !registeringFaceId">

          <!-- ── Landing ── -->
          <ng-container *ngIf="!showPasswordForm">
            <div class="card-eyebrow">ACESSO À PLATAFORMA</div>
            <h1 class="card-title">Bem-vindo de volta</h1>

            <!-- Aguardando biometria: esconde os botões, mostra spinner + opção de cancelar -->
            <div class="faceid-waiting" *ngIf="faceIdLoading">
              <mat-spinner diameter="36"></mat-spinner>
              <span class="faceid-waiting-label">Aguardando biometria...</span>
            </div>

            <ng-container *ngIf="!faceIdLoading">
              <!-- Passkey registrada: biometria como CTA primário -->
              <ng-container *ngIf="hasFaceId">
                <button type="button" class="faceid-btn faceid-btn--primary" (click)="loginWithFaceId()">
                  <svg class="faceid-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 6V4a2 2 0 0 1 2-2h2"/>
                    <path d="M16 2h2a2 2 0 0 1 2 2v2"/>
                    <path d="M20 18v2a2 2 0 0 1-2 2h-2"/>
                    <path d="M8 22H6a2 2 0 0 1-2-2v-2"/>
                    <path d="M9 10h.01"/>
                    <path d="M15 10h.01"/>
                    <path d="M9.5 15a3.5 3.5 0 0 0 5 0"/>
                    <line x1="12" y1="8" x2="12" y2="10"/>
                  </svg>
                  Entrar com Passkey
                </button>
                <div class="use-password-wrap">
                  <button type="button" class="use-password-link" (click)="showPasswordForm = true">Usar senha</button>
                </div>
              </ng-container>

              <!-- Sem passkey: senha como CTA primário + passkey sempre disponível -->
              <ng-container *ngIf="!hasFaceId">
                <button type="button" class="submit-btn" (click)="onEnterClick()">
                  Entrar
                </button>

                <ng-container *ngIf="webauthnService.isSupported()">
                  <div class="biometric-divider">OU</div>
                  <button type="button" class="faceid-btn" (click)="onPasskeyClick()">
                    <svg class="faceid-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M4 6V4a2 2 0 0 1 2-2h2"/>
                      <path d="M16 2h2a2 2 0 0 1 2 2v2"/>
                      <path d="M20 18v2a2 2 0 0 1-2 2h-2"/>
                      <path d="M8 22H6a2 2 0 0 1-2-2v-2"/>
                      <path d="M9 10h.01"/>
                      <path d="M15 10h.01"/>
                      <path d="M9.5 15a3.5 3.5 0 0 0 5 0"/>
                      <line x1="12" y1="8" x2="12" y2="10"/>
                    </svg>
                    Entrar com Passkey
                  </button>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>

          <!-- ── Password form (com sugestão opcional de Face ID) ── -->
          <ng-container *ngIf="showPasswordForm">
            <div class="card-eyebrow">ACESSO À PLATAFORMA</div>
            <h1 class="card-title">Bem-vindo de volta</h1>

            <!-- Banner de sugestão de Face ID -->
            <div class="faceid-suggestion" *ngIf="showFaceIdSuggestion">
              <svg class="faceid-icon-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 6V4a2 2 0 0 1 2-2h2"/>
                <path d="M16 2h2a2 2 0 0 1 2 2v2"/>
                <path d="M20 18v2a2 2 0 0 1-2 2h-2"/>
                <path d="M8 22H6a2 2 0 0 1-2-2v-2"/>
                <path d="M9 10h.01"/>
                <path d="M15 10h.01"/>
                <path d="M9.5 15a3.5 3.5 0 0 0 5 0"/>
                <line x1="12" y1="8" x2="12" y2="10"/>
              </svg>
              <div class="faceid-suggestion-text">
                <span class="faceid-suggestion-title">Ativar Face ID neste dispositivo?</span>
                <span class="faceid-suggestion-sub">Após o login, a biometria será configurada automaticamente.</span>
              </div>
              <div class="faceid-suggestion-actions">
                <button type="button" class="faceid-suggestion-skip" (click)="showFaceIdSuggestion = false; wantsFaceIdSetup = false">Pular</button>
                <button type="button" class="faceid-suggestion-activate" (click)="wantsFaceIdSetup = true; showFaceIdSuggestion = false">Ativar</button>
              </div>
            </div>

            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
              <div class="field-group">
                <label class="field-label">E-MAIL</label>
                <input type="email" formControlName="email" placeholder="seu@email.com"
                       class="field-input" (keydown)="onType()" autocomplete="username email">
              </div>

              <div class="field-group">
                <div class="field-label-row">
                  <label class="field-label">SENHA</label>
                  <a routerLink="/forgot-password" class="forgot-link">Esqueci minha senha</a>
                </div>
                <div class="password-wrap">
                  <input [type]="showPassword ? 'text' : 'password'" formControlName="senha" placeholder="••••••••"
                         class="field-input field-password" (keydown)="onType()" autocomplete="current-password">
                  <button type="button" class="password-toggle"
                          (click)="showPassword = !showPassword"
                          [attr.aria-label]="showPassword ? 'Ocultar senha' : 'Mostrar senha'"
                          [matTooltip]="showPassword ? 'Ocultar senha' : 'Mostrar senha'">
                    <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                </div>
              </div>

              <button type="submit" class="submit-btn" [disabled]="loginForm.invalid || loading">
                <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
                <span *ngIf="!loading">Entrar</span>
              </button>
            </form>
          </ng-container>

        </ng-container>

        <!-- MFA step (inline) -->
        <ng-container *ngIf="mfaPending && !registeringFaceId">
          <div class="card-eyebrow">VERIFICAÇÃO EM DUAS ETAPAS</div>
          <h1 class="card-title">Código de acesso</h1>
          <p class="mfa-hint">Digite o código do seu aplicativo autenticador.</p>

          <div class="otp-row" (paste)="onMfaPaste($event)">
            <input
              *ngFor="let d of digits; let i = index"
              #otpInput
              type="text"
              inputmode="numeric"
              maxlength="1"
              [value]="digits[i]"
              class="otp-input"
              [disabled]="loading"
              (focus)="onMfaFocus($event, i)"
              (input)="onMfaDigit($event, i)"
              (keydown)="onMfaKey($event, i)"
              autocomplete="one-time-code">
          </div>

          <button type="button" class="submit-btn" [disabled]="digits.join('').length < 6 || loading" (click)="onSubmit()">
            <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
            <span *ngIf="!loading">Verificar</span>
          </button>
        </ng-container>

      </div>
    </div>
  </main>

  <!-- Success -->
  <div class="success-state" *ngIf="phase === 'success'">
    <div class="success-eyebrow">NÚCLEO DESBLOQUEADO · ACESSO AUTORIZADO</div>
    <div class="success-title">Bem-vindo de volta.</div>
  </div>

  <!-- Hint -->
  <div class="login-hint" *ngIf="phase === 'form' && !mfaPending">MOVA O MOUSE · INTERAJA COM O NÚCLEO</div>

  <!-- Warp flash overlay -->
  <div class="flash-overlay" #flashEl></div>

</div>
